<div
    class="flex h-full flex-col justify-between md:flex-row md:overflow-hidden">
    <div
        class="aspect-h-1 aspect-w-3 overflow-hidden md:aspect-none md:order-2 md:h-full md:w-[40vh]">
        <app-lazy-picture
            class="block"
            [lazy]="true"
            [configurations]="featuredImageConfiguration"
            [preload]="false"></app-lazy-picture>
    </div>
    <div class="flex w-full justify-center p-8 px-12 md:order-1">
        <div class="max-w-md">
            @if (isAdditionalInfoSubmitted()) {
                <div class="text-center">
                    <h1>Enquiry sent</h1>
                    <img
                        src="/assets/images/contact/enquire_form_success.svg"
                        class="mx-auto mb-4" />
                    Thanks!
                    <br />We will be in touch shortly
                    <app-cta-button
                        [additionalClasses]="['mt-4']"
                        type="button"
                        (onClick)="closeModal()"
                        [variant]="'primary'">
                        Go back
                    </app-cta-button>
                </div>
            } @else {
                <div class="flex items-center">
                    <h1 class="w-min md:w-auto">Enquiry received</h1>
                    <img
                        src="/assets/images/contact/enquire_tick.svg"
                        class="mx-auto mb-4 w-9" />
                </div>
                <p>Any further questions?</p>
                <app-form-dynamic-with-config
                    [formSchema]="formSchema"
                    (onSubmit)="
                        submitAdditionalInfo($event)
                    "></app-form-dynamic-with-config>
            }
        </div>
    </div>
</div>
